import grouppic from "./grouppic.png";
import audience from "./audience.jpeg";
import chillax from "./chillax.jpg";
import terence from "./terence.jpeg";
import gwei from "./gwei.jpeg";
import ebai from "./ebai.jpeg";
import robbert from "./robbert.jpeg";
import akwo from "./akwo.jpeg";
import desmond2 from "./desmond2.jpg";
import deon from "./deon.jpeg";
import gaelle from "./gaelle.jpeg";
import beltus from "./beltus.jpeg";
import desmond from "./desmond.jpeg";
import kelson from "./kelson.jpeg";
import random1 from "./random1.jpeg";
import random2 from "./random2.jpeg";
import bootcamp from "./bootcamp.png";
import design from "./design.png";
import logo from "./logo.png";

export const local_images={
   grouppic,
   audience,
   gwei,
   ebai,
   terence,
   robbert,
   akwo,
   beltus,
   desmond,
   kelson,
   random1,
   random2,
   bootcamp,
   design,
   logo,
   deon,
   gaelle,
   desmond2,
   chillax
}

